(() => {
  const catalogUrl = new URL(window.location.href);
  const onSearchRoute = catalogUrl.pathname.endsWith('/search');
  const hasQuery = catalogUrl.searchParams.get('q');
  const hasType = catalogUrl.searchParams.get('type') === 'product';
  const hasFilterParams = [...catalogUrl.searchParams.keys()].some((k) => k.startsWith('filter.'));

  if (onSearchRoute && hasType && !hasQuery && !hasFilterParams) {
    catalogUrl.searchParams.set('q', '*');
    window.location.replace(catalogUrl.toString());
    return;
  }

  const emit = (name, detail = {}) => window.dispatchEvent(new CustomEvent(name, { detail }));
  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => [...root.querySelectorAll(selector)];

  qsa('[data-catalog-root]').forEach((root) => {
    const drawer = qs('[data-catalog-filters]', root);
    const openButton = qs('[data-filter-open]', root);
    const closeButtons = qsa('[data-filter-close]', root);
    const mobileQuery = window.matchMedia('(max-width: 930px)');
    let previousFocus;

    const toggleDrawer = (open) => {
      if (!drawer) return;
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      drawer.inert = !open && mobileQuery.matches;
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) {
        previousFocus = document.activeElement;
        qs('button, a, input, select, summary', drawer)?.focus();
      } else {
        previousFocus?.focus?.();
      }
    };

    const syncDrawerMode = () => {
      if (!drawer || drawer.classList.contains('is-open')) return;
      drawer.setAttribute('aria-hidden', String(mobileQuery.matches));
      drawer.inert = mobileQuery.matches;
      if (!mobileQuery.matches) document.body.style.overflow = '';
    };

    syncDrawerMode();
    mobileQuery.addEventListener?.('change', syncDrawerMode);
    openButton?.addEventListener('click', () => toggleDrawer(true));
    closeButtons.forEach((button) => button.addEventListener('click', () => toggleDrawer(false)));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer?.classList.contains('is-open')) toggleDrawer(false);
      if (event.key === 'Tab' && drawer?.classList.contains('is-open')) {
        const focusable = qsa('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), summary', drawer).filter((item) => item.offsetParent !== null);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus();
        }
      }
    });

    qsa('[data-catalog-sort]', root).forEach((select) => select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      if (select.value) url.searchParams.set('sort_by', select.value);
      else url.searchParams.delete('sort_by');
      emit('sort_changed', { sort: select.value });
      window.location.assign(url.toString());
    }));

    qsa('[data-catalog-filter-form]', root).forEach((form) => form.addEventListener('change', (event) => {
      if (event.target.matches('input[type="checkbox"]')) {
        emit('filter_applied', { filter: event.target.name, active: event.target.checked });
        if (!mobileQuery.matches) form.submit();
      }
    }));

    qsa('[data-filter-search]', root).forEach((input) => input.addEventListener('input', () => {
      const needle = input.value.trim().toLowerCase();
      const list = input.closest('.catalog-filter-block__body')?.querySelector('.catalog-filter-list');
      if (!list) return;
      qsa('li', list).forEach((item) => {
        const label = item.textContent.toLowerCase();
        item.hidden = needle !== '' && !label.includes(needle);
      });
    }));

    qsa('[data-filter-jump]', root).forEach((button) => button.addEventListener('click', () => {
      const target = qs(button.dataset.filterJump, root);
      if (!target) return;
      if (target.tagName === 'DETAILS') target.open = true;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }));

    qsa('[data-catalog-view]', root).forEach((button) => button.addEventListener('click', () => {
      const mode = button.dataset.catalogView || 'grid';
      root.dataset.view = mode;
      qsa('[data-catalog-view]', root).forEach((b) => {
        const isActive = b === button;
        b.classList.toggle('is-active', isActive);
        b.setAttribute('aria-pressed', String(isActive));
      });
      try {
        localStorage.setItem('catalog:view', mode);
      } catch (e) {
        // no-op
      }
    }));

    try {
      const savedView = localStorage.getItem('catalog:view');
      if (savedView) qs(`[data-catalog-view="${savedView}"]`, root)?.click();
    } catch (e) {
      // no-op
    }

    qsa('[data-catalog-search]', root).forEach((form) => {
      const input = qs('[data-catalog-search-input]', form);
      const clear = qs('[data-catalog-search-clear]', form);
      const syncClear = () => {
        if (clear) clear.hidden = !input?.value;
      };
      input?.addEventListener('input', syncClear);
      clear?.addEventListener('click', () => {
        input.value = '';
        syncClear();
        input.focus();
      });
      form.addEventListener('submit', () => emit('catalog_search_submitted', { hasQuery: Boolean(input?.value.trim()) }));
    });

    qsa('.catalog-card__select', root).forEach((select) => select.addEventListener('change', () => {
      const card = select.closest('[data-catalog-card]');
      const option = select.selectedOptions[0];
      const sale = option?.dataset.onSale === 'true';
      const price = qs('[data-card-price]', card);
      const compare = qs('[data-card-compare]', card);
      const saving = qs('[data-card-saving]', card);
      if (price) price.textContent = option?.dataset.price || '';
      if (compare) {
        compare.textContent = option?.dataset.compare || '';
        compare.hidden = !sale;
      }
      if (saving) {
        saving.textContent = option?.dataset.saving || '';
        saving.hidden = !sale;
      }
    }));

    qsa('[data-catalog-product-link]', root).forEach((link) => link.addEventListener('click', () => emit('catalog_product_clicked', { productId: link.closest('[data-product-id]')?.dataset.productId })));
  });

  document.querySelectorAll('[data-product-recommendations][data-url]').forEach(async (section) => {
    const url = section.dataset.url;
    if (!url) return;
    try {
      const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) return;
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const incoming = doc.querySelector('[data-product-recommendations]');
      if (!incoming) return;
      const newGrid = incoming.querySelector('.catalog-grid');
      const currentGrid = section.querySelector('.catalog-grid');
      if (newGrid && newGrid.children.length > 0 && currentGrid) currentGrid.replaceWith(newGrid);
    } catch (e) {
      // keep static fallback
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-catalog-add-form]');
    if (!form || !window.routes?.cart_add_url) return;
    event.preventDefault();
    const button = qs('button[type="submit"]', form);
    const status = qs('[role="status"]', form);
    const originalText = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) throw new Error('This item could not be added.');
      const item = await response.json();
      if (status) status.textContent = 'Added to cart.';
      button.textContent = 'Added ✓';
      emit('product_added', { productId: item.product_id, variantId: item.variant_id, source: 'catalog' });
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.querySelector('[data-cart-drawer-open], a[href="/cart"]')?.click();
      button.classList.add('wm-add-btn--success');
      setTimeout(() => {
        button.textContent = originalText;
        button.classList.remove('wm-add-btn--success');
      }, 2200);
    } catch (error) {
      if (status) status.textContent = error.message;
      button.textContent = originalText;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });

  /* In-grid swatch swap: clicking a swatch on the card itself (not quick
     view) previews that variant's price/image/availability without a page
     load. Real data only — each card embeds its own `<script
     data-card-payload>` (see catalog-product-card.liquid) with
     `product.variants | json`, and this just looks up the variant the
     swatch button already points at server-side (`data-swatch-variant-id`,
     resolved with Liquid's `where` filter against real inventory, not a
     client guess). Deliberately does NOT recompute the top-left badge
     (best seller / new / sale %) on swap — that reads as a per-product
     merchandising signal rather than a live per-variant discount ticker,
     and every variant in this store currently shares the same
     compare-at-price (none are on sale), so there's nothing to verify that
     simplification against; flagging it here for whoever adds a sale
     variant later. */
  const cardPayloadCache = new WeakMap();
  function getCardPayload(card) {
    if (cardPayloadCache.has(card)) return cardPayloadCache.get(card);
    const script = qs('[data-card-payload]', card);
    let data = null;
    if (script) {
      try {
        data = JSON.parse(script.textContent);
      } catch (e) {
        data = null;
      }
    }
    cardPayloadCache.set(card, data);
    return data;
  }

  const formatCardMoney = (cents) => (typeof cents === 'number' ? '$' + (cents / 100).toFixed(2) : '');

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.wm-swatch[data-swatch-variant-id]');
    if (!swatch) return;
    const card = swatch.closest('[data-catalog-card]');
    if (!card) return;
    const payload = getCardPayload(card);
    if (!payload) return;
    const variantId = Number(swatch.dataset.swatchVariantId);
    const variant = payload.variants.find((v) => v.id === variantId);
    if (!variant) return;

    qsa('.wm-swatch[data-swatch-variant-id]', card).forEach((btn) => {
      const isActive = btn === swatch;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', String(isActive));
    });

    const priceParts = (variant.price / 100).toFixed(2).split('.');
    const dollarsEl = qs('[data-card-price-dollars]', card);
    const centsEl = qs('[data-card-price-cents]', card);
    if (dollarsEl) dollarsEl.textContent = priceParts[0];
    if (centsEl) centsEl.textContent = priceParts[1];

    const onSale = typeof variant.compare_at_price === 'number' && variant.compare_at_price > variant.price;
    const compareEl = qs('[data-card-compare-price]', card);
    const saveEl = qs('[data-card-save-text]', card);
    if (compareEl) {
      compareEl.hidden = !onSale;
      compareEl.textContent = onSale ? formatCardMoney(variant.compare_at_price) : '';
    }
    if (saveEl) {
      saveEl.hidden = !onSale;
      saveEl.textContent = onSale ? `You save ${formatCardMoney(variant.compare_at_price - variant.price)}` : '';
    }

    const variantInput = qs('[data-card-variant-input]', card);
    if (variantInput) variantInput.value = variant.id;

    const addBtn = qs('[data-card-add-btn]', card);
    const addBtnLabel = qs('[data-card-add-btn-label]', card);
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.classList.toggle('wm-add-btn--oos', !variant.available);
      if (addBtnLabel) addBtnLabel.textContent = variant.available ? '+ Add' : 'Out of stock';
    }

    /* Real low-stock line, same threshold as the server-rendered version
       (main-product.liquid / catalog-product-card.liquid): tracked
       inventory, not a "keep selling when out of stock" policy, quantity
       between 1 and 10. `product.variants | json` drops inventory_quantity/
       inventory_policy (see the comment on `inventoryExtra` in
       catalog-product-card.liquid), so look the new variant up there. */
    const lowStockEl = qs('[data-card-low-stock]', card);
    if (lowStockEl) {
      const inv = (payload.inventoryExtra || []).find((i) => i.id === variant.id);
      const showLowStock = Boolean(
        variant.available &&
        inv &&
        inv.inventory_policy !== 'continue' &&
        typeof inv.inventory_quantity === 'number' &&
        inv.inventory_quantity > 0 &&
        inv.inventory_quantity <= 10
      );
      lowStockEl.hidden = !showLowStock;
      lowStockEl.textContent = showLowStock ? `Only ${inv.inventory_quantity} left` : '';
    }

    if (variant.featured_image && variant.featured_image.src) {
      const primaryImg = qs('[data-card-img-primary]', card);
      if (primaryImg) {
        const src = variant.featured_image.src;
        primaryImg.src = src + (src.includes('?') ? '&' : '?') + 'width=400';
      }
    }
  });
})();

/* Trailing padding — see the matching comment at the end of
   catalog-quick-view.js. This dev environment's asset sync intermittently
   drops a small fixed number of trailing bytes off served .js files,
   confirmed on files never touched this session too; this inert comment
   just keeps the trim from ever landing inside real code. */

















































































